<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h2>Stock de Materia Prima en Pozo</h2>
                <div class="row">
                    <div class="col text-right">
                        <p>
                            <!-- <button class="btn btn-primary" type="button" data-toggle="collapse" id="button-stock" @click="nuevo"
                                data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                Nuevo
                            </button> -->
                            <button class="btn btn-primary" type="button" id="button-stock" @click="nuevo">
                                Registro de Stock
                            </button>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">



                        <div :class="`collapse ${show?'show':''}`" id="collapseExample">
                            <div class="card-body flex justify-between">
                                <input type="date" name="" id="" v-model="fecha" @change="cargar_stocks">
                                <button class="btn btn-default" @click="guardar">{{texto_boton}}</button>

                            </div>
                            <div class="card card-body">
                                <!-- <div class="flex flex-center">
                                    <h4>POZO</h4>
                                    <h4 class="mx-2">Cantidad Materia Prima (Kg)</h4>
                                </div>
                                <div class="flex flex-center" v-for="p in stocks">
                                    <p class="">{{p.pozo}}</p>
                                    <input class="mx-2 my-2" type="number" v-model="p.kg">
                                </div> -->

                                <table class="table table-sm table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Linea</th>
                                            <th>Pozo</th>
                                            <th>Stock Inicial (Kg)</th>
                                            <th>Ingreso Materia Prima (Kg)</th>
                                            <th>Stock en Pozo (Kg)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="p in stocks">
                                            <td>{{p.linea}}</td>
                                            <td>{{p.pozo}}</td>
                                            <td>{{p.stock_inicial}}</td>
                                            <td>{{p.ingresos_mp_fecha}}</td>
                                            <td><input class="mx-2 my-2" type="number" v-model="p.kg"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </div>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        pozos: [],
        stocks: [],
        fecha: new Date().toISOString().split('T')[0],
        button: null,
        show: false,
        texto_boton: 'Guardar'
    }),
    mounted() {
        this.button = document.getElementById("button-stock")
        this.cargar_pozos()
    },
    methods: {
        async cargar_stocks() {
            this.limpiar()
            await this.axios
                .get(`${this.api}/pozos_stock/fecha/${this.fecha}`, this.cabeceras_json)
                .then((res) => {
                    //this.pozos = res.data.data.data;
                    console.log('stocks', res.data.data)
                    this.stocks.forEach((item, i) => {
                        let stock = res.data.data.stocks.find(s => s.pozos_id == item.pozos_id)
                        let stock_pozo = res.data.data.stock_pozos.find(s => s.id == item.pozos_id)
                        if(stock){
                            item.kg = stock.kg
                        }

                        item.stock_inicial = stock_pozo?.stock_inicial
                        item.ingresos_mp_fecha = stock_pozo?.ingreso_mp_fecha
                    })
                })
                .catch((e) => {
                    //console.log(e);
                });
        },

        limpiar(){
            this.stocks.forEach(s => {
                 s.kg = null
            })
        },
        async cargar_pozos() {
            await this.axios
                .get(`${this.api}/pozos?limit=9999999`, this.cabeceras_json)
                .then((res) => {
                    this.pozos = res.data.data.data;
                    this.pozos.forEach(p => {
                        this.stocks.push({
                            id: null,
                            linea: p.linea_texto,
                            pozo: p.nombre,
                            pozos_id: p.id,
                            kg: null,
                            stock_inicial:null,
                            ingresos_mp_fecha:null
                        })
                    })
                })
                .catch((e) => {
                    //console.log(e);
                });
                this.cargar_stocks()
        },
        nuevo() {
            this.show = !this.show
            // this.texto_boton = 'Registrar Stock'
            // this.stocks.forEach(s => {
            //     s.kg = null
            // })

        },
        async guardar() {
            await this.axios.post(`${this.api}/pozos_stock`, {
                fecha: this.fecha,
                stocks: this.stocks
            }, this.cabeceras_json).then(r => {
                console.log('guardado/actualizado', r)
            }).catch(e => {
                console.log(e)
            })
        }
    },
    computed: {
        ...mapState(['api', 'cabeceras_json'])
    }
}
</script>